import React, { useState, useEffect } from "react";
import "./LoginPage.css";
import {
  Row,
  Container,
  Form,
  InputGroup,
  Tab,
  Tabs,
  FormControl,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { loginrequest } from "../util/login";
import { toast } from "react-toastify";
import { fetchLogindata } from "../redux/actions";
import { useTranslation } from "react-i18next";
import { findAccountdeletedrequest } from "../util/findAccountIfDeleted";
import { updateCartrequest } from "../../otpverification/util/updateCart";
import { maintanCheckoutpage } from "../../home/redux/actions";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import "react-phone-input-2/lib/style.css";
import startsWith from "lodash.startswith";
import { EYE, EYE_OFF } from "../../comman/components/CommonimagePath";
import { sendOtprequest } from "../../otpverification/util/sendOtp";
import PhoneInputPage from "../../comman/phoneinput/PhoneInputPage";
import FormgroupPage from "../../comman/formgroup/FormgroupPage";
import { maintainCartdata } from "../../home/redux/actions";
import { maintainCabbook } from "../../home/redux/actions";
import ButtonPage from "../../comman/button/ButtonPage";
const OtpPage = React.lazy(() =>
  import("../../otpverification/components/OtpPage")
);

function LoginPage(props) {
  const emailRegex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  const { t } = useTranslation();
  const [page_from, setpage_from] = useState("login");
  const passRegex =
    /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\w\W]){1,})(?!.*\s).{8,}$/;
  const [showotp, setShowotp] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showmail, setShowmail] = useState(false);
  const [errorMsg, setErrormsg] = useState({
    email: "",
    mobile: "",
    country_code: "",
    password: "",
  });
  const [secure, setSecure] = useState(true);
  const [inputvalue, setInputvalue] = useState({
    mobile: "",
    email: "",
    password: "",
    otp: "",
    country_code: "90",
    country_isocode: "tr",
  });
  const [logintype, setLogintype] = useState("customer");
  const [phoneinput, setPhoneinput] = useState();
  const [mobileexist, setMobileexist] = useState(false);
  const navigate = useNavigate();

  // eslint-disable-next-line
  useEffect(() => {
    (async () => callvendordashboard())();
    // eslint-disable-next-line
  }, [props.logindata]);

  useEffect(() => {
    (async () => onChangeTab(logintype))();
    // eslint-disable-next-line
  }, [props?.language, logintype]);

  const onChangeTab = (logintype) => {
    if (logintype === "customer")
      props?.fetchHeaderContent(t("pages.meta.login.title"), t("pages.meta.login.description"), "");
    else
      props?.fetchHeaderContent(t("pages.meta.login.title"), t("pages.meta.login.description"), "");
  };

  const callvendordashboard = () => {
    if (props?.access_token) {
      if (props?.navigatecheckout === "checkout") {
      } else if (props?.navigatecheckout === "cart") {
      } else {
        if (props?.type === "user") {
          navigate("/");
        } else {
          navigate("/vendor/dashboard");
        }
      }
    }
  };

  const validation = () => {
    let checkValue = "";
    if (showmail) {
      if (!emailRegex.test(inputvalue.email)) {
        errorMsg.email = "pages.login.email-warn";
        checkValue = "false";
      }
      if (!passRegex.test(inputvalue.password)) {
        errorMsg.password = "pages.login.password_valid";
        checkValue = "false";
      }
      if (inputvalue.password === "") {
        errorMsg.password = "pages.login.password_warn";
        checkValue = "false";
      }
      setErrormsg({
        mobile: "",
        email: errorMsg.email,
        password: errorMsg.password,
      });
    } else {
      if (inputvalue.mobile === "") {
        errorMsg.mobile = "pages.login.number_valid";
        checkValue = "false";
      }
      if (errorMsg.country_code !== "") {
        errorMsg.mobile = "";
        checkValue = "false";
      }
      setErrormsg({
        ...errorMsg,
        mobile: errorMsg.mobile,
        email: "",
        password: "",
      });
    }
    if (checkValue === "false") {
      return false;
    } else {
      return true;
    }
  };

  const loginWithmail = (e) => {
    e.preventDefault();
    var ifConnected = window.navigator.onLine;
    if (ifConnected) {
      setShowmail(true);
    } else {
      toast.error(t("pages.Internet connection not available"));
    }
  };

  const loginWithmobile = (e) => {
    e.preventDefault();
    var ifConnected = window.navigator.onLine;
    if (ifConnected) {
      setShowmail(false);
    } else {
      toast.error(t("pages.Internet connection not available"))
    }
  };

  const inputvalueChange = (e) => {
    setInputvalue({
      ...inputvalue,
      [e.target.name]: e.target.value,
    });

    switch (e.target.name) {
      case "mobile":
        setErrormsg({
          ...errorMsg,
          mobile: "",
        });
        break;
      case "email":
        setErrormsg({
          ...errorMsg,
          email: "",
        });
        break;
      case "password":
        setErrormsg({
          ...errorMsg,
          password: "",
        });
        break;
      default:
        break;
    }
  };

  const sendOtp = async (e) => {
    setLoader(true);
    e.preventDefault();
    var ifConnected = window.navigator.onLine;
    if (ifConnected) {
      if (validation()) {
        let findAccountdeletedresponse = await findAccountdeletedrequest(
          inputvalue.mobile,
          inputvalue.country_code
        );
        if (findAccountdeletedresponse?.status === 200) {
          toast.error(t("pages.Your account deleted please contact to admin"));
        } else if (findAccountdeletedresponse?.status === 404) {
          if (showmail) {
            await callLogin();
          } else {
            // calling otp
            let sendOtpresponse = await sendOtprequest(
              inputvalue.mobile,
              inputvalue.country_code,
              props?.language?.toLowerCase()
            );
            if (
              sendOtpresponse?.status === 200 ||
              sendOtpresponse?.status === 201
            ) {
              let result = await sendOtpresponse.json();
              if (result?.data?.mobile_already_exist === "yes") {
                setMobileexist(true);
              } else {
                setMobileexist(false);
              }
              setShowotp(true);
            } else if (sendOtpresponse?.status === 400) {
              let responce = await sendOtpresponse.json();
              toast.error(responce?.errors);
              setShowotp(false);
            }
          }
        }
      }
    } else {
      toast.error(t("pages.Internet connection not available"))
    }
    setTimeout(() => setLoader(false), 200);
  };

  const callLogin = async () => {
    let loginresponse = await loginrequest(
      inputvalue.email,
      inputvalue.password,
      props?.language?.toLowerCase()
    );
    if (loginresponse?.status === 200) {
      let loginData = await loginresponse.json();
      props.fetchLogindata(loginData.data);
      updateCart(loginData);
    } else if (loginresponse.status === 400) {
      await loginresponse.json();
      if (props?.language === "Tr") {
        toast.error("Yanlış e-posta kimliği veya şifre.");
      } else {
        toast.error("Incorrect email id or password.");
      }
    }
  };

  const updateCart = async (loginData) => {
    if (props?.cartdata?.length > 0) {
      let object = {};
      let productlist = [];
      props?.cartdata?.forEach((product) => {
        object = {
          store_id: product?.store_id,
          product_id: product?.product_id,
          variation_id: product?.variation_id,
          quantity: product?.quantity,
          id: product?.id,
        };
        productlist.push(object);
      });
      let data = {
        cartdata: productlist,
      };
      const updateCartresponse = await updateCartrequest(
        loginData?.data?.token?.access_token,
        data,
        props?.language?.toLowerCase()
      );
      if (updateCartresponse?.status === 200) {
        redireactionPage(loginData);
      } else if (updateCartresponse?.status === 400) {
        let getErrormsg = await updateCartresponse.json();
        toast.error(getErrormsg?.errors);
        props.maintainCartdata([], {});
        redireactionPage(loginData);
      }
    } else {
      redireactionPage(loginData);
    }
  };

  const redireactionPage = (loginData) => {
    if (props?.navigatecheckout === "checkout") {
      navigate("/checkout");
    } else if (props?.navigatecheckout === "cart") {
      props.maintanCheckoutpage("");
      navigate("/cart");
    } else if (props?.navigateCabbook?.flag === "cab_book") {
       let getId = props?.navigateCabbook?.id;
       navigate(`/cab-book/${getId}`);
       props.maintainCabbook({flag:"",id:""});
    } else {
      if (loginData?.data?.type === "user") {
        navigate("/");
      } else {
        navigate("/vendor/dashboard");
      }
    }
  }

  const redirectTosignup = () => {
    navigate("/signup");
  };

  const redirectToforgot = () => {
    navigate("/forgot");
  };

  const countryChange = (value, data) => {
    let getValue =
      startsWith(value, data?.dialCode) || startsWith(data?.dialCode, value);
    if (getValue === false) {
      setErrormsg({
        ...errorMsg,
        mobile: "",
        country_code: "pages.login.country_code_valid",
      });
    } else {
      setErrormsg({
        ...errorMsg,
        mobile: "",
        country_code: "",
      });
    }
    setPhoneinput(value);
    let phonecode = { rawPhone: value.slice(data.dialCode.length) };
    setInputvalue({
      ...inputvalue,
      mobile: phonecode?.rawPhone?.toString(),
      country_code: data?.dialCode.toString(),
      country_isocode: data.countryCode,
    });
  };

  return (
    <>
      <section className="login-section common_login-section">
        <div className="login-container">
          <Container>
            <Row className="justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-10 col-xl-10">
                <div className="auth common_box">
                  <Row>
                    <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                      {showotp === false ? (
                        <Form className="login-form">
                          <div className="loginparent-tab">
                            <Tabs
                              activeKey={logintype}
                              onSelect={(k) => setLogintype(k)}
                            >
                              <Tab
                                eventKey="customer"
                                title={t("pages.login.customer")}
                              ></Tab>
                              <Tab
                                eventKey="owner"
                                title={t("pages.login.busi_ower")}
                              ></Tab>
                            </Tabs>
                          </div>

                          <div className="form-header">
                            <h2>{t("pages.login.title")}</h2>
                            <h6>{t("pages.login.subtitle")}</h6>
                          </div>
                          {showmail === false ? (
                            <>
                              <div className="form-content">
                                <PhoneInputPage
                                  country={inputvalue.country_isocode}
                                  enableSearch={true}
                                  value={phoneinput}
                                  className={"countrylist"}
                                  onChange={(value, data) =>
                                    countryChange(value, data)
                                  }
                                />
                                <div className="text-danger">
                                  {t(errorMsg.country_code)}
                                  {t(errorMsg.mobile)}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="form-content">
                              <FormgroupPage
                                className="form-group"
                                label={''}
                                placeholder={t("pages.login.email")}
                                value={inputvalue.email}
                                name="email"
                                type={"text"}
                                onChange={(e) => inputvalueChange(e)}
                                error={t(errorMsg.email)}
                                require={false}
                              />
                              <div className="form-group">
                                <InputGroup className="right_border-0">
                                  <FormControl
                                    placeholder={t("pages.login.password")}
                                    name="password"
                                    value={inputvalue.password}
                                    onChange={(e) => inputvalueChange(e)}
                                    type={secure ? "password" : "text"}
                                  />
                                  <InputGroup.Text
                                    onClick={() => setSecure(!secure)}
                                  >
                                    <img
                                      src={secure ? EYE_OFF : EYE}
                                      alt="hide"
                                      height="20"
                                      width="20"
                                    ></img>
                                  </InputGroup.Text>
                                </InputGroup>
                                <div className="text-danger">
                                  {t(errorMsg.password)}
                                </div>
                              </div>
                              <div className="remember-hint d-flex justify-content-between pt-2">
                                <Form.Check
                                  label={t("pages.login.remeber_me")}
                                />
                                <h6 onClick={() => redirectToforgot()}>
                                  {t("pages.login.forgot")}
                                </h6>
                              </div>
                            </div>
                          )}
                          <ButtonPage
                            className="button-submit w-100 mb-4 mt-4"
                            onClick={(e) =>
                              loader ? e.preventDefault() : sendOtp(e)
                            }
                            Text={loader ? (
                              <Spinner animation="border" />
                            ) : (
                              t("pages.login.submit")
                            )}
                          />
                          <h5 className="m-0 pb-4">{t("pages.login.or")}</h5>
                          {showmail === false ? (
                            <ButtonPage
                              className="button-black w-100 center_icon_title"
                              onClick={(e) => loginWithmail(e)}
                              Text={
                                <React.Fragment>
                                  <span className="email_icon" />
                                  {t("pages.login.log_email_btn")}
                                </React.Fragment>
                              }
                            />
                          ) : (
                            <ButtonPage
                              className="button-black w-100 center_icon_title"
                              onClick={(e) => loginWithmobile(e)}
                              Text={t("pages.login.login_mobile")}
                            />
                          )}

                          <div className="signupque text-center">
                            <h6>
                              {t("pages.login.not_account")}{" "}
                              <span onClick={() => redirectTosignup()}>
                                {t("pages.login.signup")}
                              </span>
                            </h6>
                          </div>
                        </Form>
                      ) : (
                        <OtpPage
                          showotp={showotp}
                          setShowotp={setShowotp}
                          inputvalue={inputvalue}
                          logintype={logintype}
                          page_from={page_from}
                          setpage_from={setpage_from}
                          setMobileexist={setMobileexist}
                          mobileexist={mobileexist}
                        ></OtpPage>
                      )}
                    </div>
                  </Row>
                </div>
              </div>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => ({
  logindata: state?.login?.logindata,
  access_token: state?.login.access_token,
  type: state?.login.type,
  language: state?.languageState?.language,
  navigatecheckout: state?.home?.navigatecheckout,
  navigateCabbook: state?.home?.navigateCabbook,
  cartdata: state?.home?.cartdata,
  currentLocation: state?.home?.currentLocation,
});

export default connect(mapStateToProps, {
  fetchLogindata,
  maintanCheckoutpage,
  maintainCabbook,
  fetchHeaderContent,
  maintainCartdata
})(LoginPage);
